<template>
  <div class="box content">
    <h1 class="title">Create Customer</h1>

    <div class="columns is-centered" v-if="showTags">
      <div class="column is-half">
        <b-field label="Tags">
          <b-taginput
            :value="data.tags"
            @input="setTags"
            :data="tagsAutofill"
            autocomplete
          ></b-taginput>
        </b-field>
      </div>
    </div>

    <form-wizard
      :data="data"
      :fields="fields"
      :metadata="$metadata"
      @submit="onSubmit"
    ></form-wizard>
  </div>
</template>

<script>
import Library from '@/library'

export default {
  name: 'CreateCustomerStepOne',

  data () {
    return {
      data: {}
    }
  },

  methods: {
    setTags (e) {
      this.$set(this.data, 'tags', e)
    },

    async onSubmit (data) {
      const loader = this.$loading.open()
      try {
        const response = await this.$entity.create(Library.Enums.ObjectType.Customer, {
          ...data,
          status: 'Active'
        })

        this.$router.push({
          name: 'Create Customer',
          params: {
            customerId: response.data.id,
            step: '2'
          }
        })
      } catch (e) {
        console.error(e)
      } finally {
        loader.close()
      }
    }
  },

  computed: {
    fields () {
      return Library.Entities.getCreateFields(Library.Enums.ObjectType.Customer).StepOne
    },

    showTags () {
      if (this.$metadata && this.$metadata.properties && this.$metadata.properties.find(prop => prop.propertyName === 'tags')) {
        return true
      } else {
        return false
      }
    },

    tagsAutofill () {
      if (this.showTags) {
        const autofill = this.$metadata.properties.find(prop => prop.propertyName === 'tags');

        return autofill.options.possibleValues || []
      }
    }
  },

  components: {
    FormWizard: Library.Components.FormWizard
  }
}
</script>
